import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./project.css";
import NFTs from "../../_metadata.json";
import img from "../../assets/1.png";
import abi from "../../abi.json";
import abi2 from "../../abi2.json";

import Web3 from "web3";
const { ethereum } = window;
const web3 = new Web3(ethereum);
const address = "0xFAc96E4e3201e6928C1a2d3E8bd6B8d5072C7648";
const address2 = "0xFDEf6e24E560fAc0A8705Ad51F9B55F1FC10cB91";

const chainID = 1;

function Project() {
  const [currentPost, setCurrentPost] = useState([]);

  useEffect(() => {
    const list = NFTs.sort((a, b) => a.Rarity - b.Rarity);
    setCurrentPost(list.slice(1, 4));
  }, []);

  const getOwner = async (e, id) => {
    if (window.ethereum) {
      const contract = new web3.eth.Contract(abi, address);
      const contract2 = new web3.eth.Contract(abi2, address2);
      await web3.eth.net.getId().then(async (netId) => {
        if (netId != chainID) {
        } else {
          try {
            const token = await contract.methods.ownerOf(id).call();
            const owner =
              String(token).substring(0, 6) +
              "..." +
              String(token).substring(38);
            e.target.innerHTML = "Owner : " + owner;
          } catch (error) {
            try {
              const token = await contract2.methods.ownerOf(id).call();
              const owner =
                String(token).substring(0, 6) +
                "..." +
                String(token).substring(38);
              e.target.innerHTML = "Owner : " + owner;
            } catch (error) {
              e.target.innerHTML = "NFT not Minted Yet";
            }
          }
        }
      });
    } else {
      return {
        address: "",
        status: (
          <span>
            <p>
              {" "}
              🦊{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://metamask.io/download.html`}
              >
                You must install Metamask, a virtual Ethereum wallet, in your
                browser.
              </a>
            </p>
          </span>
        ),
      };
    }
  };

  const nfts = [
    {
      image: img,
      title: "NFT 001",
      subtitle: "#453",
      value: "15.2 ETH",
    },
    {
      image: img,
      title: "NFT 001",
      subtitle: "#452",
      value: "15.2 ETH",
    },
    {
      image: img,
      title: "NFT 001",
      subtitle: "#451",
      value: "15.2 ETH",
    },
  ];

  return (
    <section
      className="container project_container"
      id="nftproject"
      style={{
        margin: "60px auto",
      }}
    >
      <h2>Top 3 available rare MonkeyDoo</h2>

      <div className="image_cards">
        {currentPost.map((nft, i) => (
          <article className="image_card" key={i}>
            <img
              src={`https://monkeydoonft.online/images/${nft.edition}.png`}
              style={{
                padding: "15px",
              }}
            />
            <div className="card_text">
              <h5>MonkeyDoos #{nft.edition}</h5>
              <h3>Rarity #{nft.Rarity_Score}</h3>
              <a
                style={{
                  color: "#111",
                  cursor: "pointer",
                }}
                onClick={(e) => getOwner(e, nft.edition)}
              >
                Click to see if Minted
              </a>
            </div>
          </article>
        ))}
      </div>
      <Link
        to="/monkedoos"
        className="btn btn-primary"
        style={{
          height: "initial",
        }}
      >
        See More{" "}
      </Link>
    </section>
  );
}

export default Project;
